import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { getKilogramsAndGramsFromGrams } from 'ui-components/components/weight-input/helpers';

import style from './style.module.less';
import { WeightDisplay } from './weight-display';
import { WeightUnit } from '../../../../../enums/weight-unit';

export const DisplayUnit = {
  Pounds: 'LB',
  Ounces: 'OZ',
  Grams: 'GR',
  Kilograms: 'KG',
};

const DECIMAL_EXTRACTOR = 100;

const OunceUnitDisplay = (weight) => {
  const lbValue = Math.floor(weight / 16);
  const ozValue = Math.floor((weight % 16) * 100) / 100;

  return (
    <>
      <WeightDisplay unit={DisplayUnit.Pounds} weight={lbValue} />
      <WeightDisplay unit={DisplayUnit.Ounces} weight={ozValue} />
    </>
  );
};

const KilogramAndGramsUnitDisplay = (weight) => {
  const { kilograms, grams } = getKilogramsAndGramsFromGrams(weight, DECIMAL_EXTRACTOR);

  return (
    <>
      <WeightDisplay unit={DisplayUnit.Kilograms} weight={kilograms} />
      <WeightDisplay unit={DisplayUnit.Grams} weight={grams} />
    </>
  );
};

export const ScaleWeightDisplay = ({ weight, unit }) => {
  const unitDisplay = useMemo(() => {
    if (unit === WeightUnit.Ounces) {
      return OunceUnitDisplay;
    }
    return KilogramAndGramsUnitDisplay;
  }, [unit]);

  return (
    <div className={style['scale-readout-wrapper']}>
      <span className={style['scale-readout']}>{unitDisplay(weight)}</span>
    </div>
  );
};

ScaleWeightDisplay.propTypes = {
  weight: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
};
